import noiseVertexSource from './glsl/noise.vertex';
import colorFragmentSource from './glsl/color.frag';

const zeros = n => new Float32Array(n);

/* Set in shader, value must match.  See note in shader before increasing. */
const NPOINTS = 100;

export default class NoiseScope {

	static _inst = 0;

	_gl = null;
	_shader = null;
	_line = null;
	_data = null;
	_brightness = null;
	_thickness = null;

	constructor(gl, gor) {
		this._inst = NoiseScope._inst++;
		this._gl = gl;
		try {
			this._shader = gor.createShaderProgram(`noise${this._inst}`, noiseVertexSource, colorFragmentSource);
			this._line = gor.createVertexBuffer(`noise${this._inst}`, 'interp', 2, true);
			/* Generate edge */
			const interp = new Float32Array((NPOINTS * 2 + 1) * 4);
			for (let i = -NPOINTS; i <= NPOINTS; i++) {
				interp[(i + NPOINTS) * 4 + 0] = i;
				interp[(i + NPOINTS) * 4 + 1] = 1;
				interp[(i + NPOINTS) * 4 + 2] = i;
				interp[(i + NPOINTS) * 4 + 3] = -1;
			}
			this._line.update(interp);
			this._data = zeros(NPOINTS);
			this._brightness = zeros(NPOINTS);
			this._thickness = zeros(NPOINTS);
		} catch (e) {
			console.error(e);
			throw new Error(`Failed to initialise ${this.constructor.name}`);
		}
	}

	defaultOpts() {
		return {
			npoints_const: NPOINTS,
			scale: [0, 0],
			mirror: false,
			data: this._data,
			brightness: this._brightness,
			thickness: this._thickness,
			displacement: 0,
			base_color: zeros(4)
		};
	}

	draw(opts) {
		const gl = this._gl;
		const shader = this._shader;
		shader.select();
		shader.setUniform('scale', opts.scale);
		shader.setUniform('mirror', opts.mirror ? 1 : 0);
		shader.setUniform('data[0]', opts.data || this._data);
		shader.setUniform('brightness[0]', opts.brightness || this._brightness);
		shader.setUniform('thickness[0]', opts.thickness || this._thickness);
		shader.setUniform('displacement', opts.displacement);
		shader.setUniform('base_color', opts.base_color);
		this._line.draw(shader, gl.TRIANGLE_STRIP);
	}

}
